import React from "react";

export default function PageHero({ title, subtitle, image }) {
  return (
    <section className="page-hero" style={{ backgroundImage: `url(${image})` }}>
      <div className="overlay">
        <div className="page-hero-content">
          <h1 className="title">{title}</h1>
          {subtitle && <p className="subtitle">{subtitle}</p>}
        </div>
      </div>
      <svg className="wave" viewBox="0 0 1440 120" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="waveGrad" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#6a11cb" />
            <stop offset="1" stopColor="#2575fc" />
          </linearGradient>
        </defs>
        <path d="M0,80 C240,120 480,0 720,60 C960,120 1200,20 1440,80 L1440,140 L0,140 Z" fill="url(#waveGrad)" fillOpacity="0.35" />
      </svg>
      <svg className="wave wave-2" viewBox="0 0 1440 120" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="waveGrad2" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#ff5f6d" />
            <stop offset="1" stopColor="#ffc371" />
          </linearGradient>
        </defs>
        <path d="M0,90 C220,130 520,30 820,70 C1040,100 1240,40 1440,90 L1440,140 L0,140 Z" fill="url(#waveGrad2)" fillOpacity="0.35" />
      </svg>
    </section>
  );
}